import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TableStyle } from '../../../models/enums/tableStyle';
import { Sort } from '@angular/material/sort';
import { BenchmarkStore } from '../../../core/services/tables/benchmark.store';
import { BenchmarkService } from '../../../core/services/tables/benchmark.service';
import { InfoService } from '../../../core/services/tables-info/info.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { AuthService } from 'src/app/core/services/user-services/auth.service';
import { Helpers } from 'src/app/models/Helpers/helpers';
import { WatchlistsService } from 'src/app/core/services/watchlists/watchlists.service';
import {AddToWatchlistManagerService} from '../../../core/services/watchlists/add-to-watchlist-manager.service';

@Component({
  selector: 'app-benchmark-table',
  templateUrl: './benchmark-table.component.html',
  styleUrls: ['./benchmark-table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: 0, padding: 0 })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('0.3s cubic-bezier(0.77, 0, 0.175, 1)'))
    ]),
  ]
})
export class BenchmarkTableComponent implements OnInit {
  @Output() getData: EventEmitter<any> = new EventEmitter<any>();
  @Output() updatePageSize: EventEmitter<any> = new EventEmitter<any>();

  @Input() style: TableStyle;
  @Input() state;

  @Input() pageSize;
  @Input() pageNumber;
  @Input() totalPages;
  @Input() showLoader;

  tableStyle = TableStyle;
  isAlreadyFetched: boolean;
  filter: string;
  ascending: boolean;
  isGuest = false;

  tableInfoExists: boolean;

  constructor(
    public store: BenchmarkStore,
    private service: BenchmarkService,
    private infoService: InfoService,
    public dialogService: DialogService,
    private userService: AuthService,
    private addToWatchlistManager: AddToWatchlistManagerService
  ) {
    this.userService.userManager.getUser().then(
      user => this.isGuest = user?.profile?.role === 'CedLabGuest'
    );
  }


  ngOnInit(): void {
    this.tableInfoExists = this.infoService.isThereInfo(this.store.title);
    this.isAlreadyFetched = this.state === 'expanded';
  }

  localeCurrency(currency: string) {
    return Helpers.getCurrencyLocale(currency);
  }
  currencySymbol(currency: string) {
    return Helpers.getCurrencySymbol(currency);
  }

  getRecords(pageNumber: number) {
    this.getData.emit({ pageNumber, filter: this.filter, ascending: this.ascending });
    this.isAlreadyFetched = true;
  }

  deepSortRecords({ active, direction }) {
    this.filter = active;
    this.ascending = direction === 'asc' ? true : direction === 'desc' ? false : null;
    this.getData.emit({ pageNumber: this.pageNumber, filter: this.filter, ascending: this.ascending });
  }

  toggle() {
    this.state = this.state === 'collapsed' ? 'expanded' : 'collapsed';
    if (!this.isAlreadyFetched) {
      this.getData.emit(this.pageNumber);
    }
    this.isAlreadyFetched = true;
  }

  nextPage() {
    ++this.pageNumber;
    this.getRecords(this.pageNumber);
  }

  previousPage() {
    --this.pageNumber;
    this.getRecords(this.pageNumber);
  }

  firstPage() {
    this.pageNumber = 1;
    this.getRecords(this.pageNumber);
  }

  lastPage() {
    this.pageNumber = this.totalPages;
    this.getRecords(this.pageNumber);
  }

  updateSize(event: any) {
    this.updatePageSize.emit({ event, filter: this.filter, ascending: this.ascending });
  }

  sendSortData(sort: Sort) {
    this.service.sorting(sort);
  }

  sendSortDataGuest(sort: Sort) {
    this.service.sortingGuest(sort);
  }

  openDialog() {
    const tableInfo = this.infoService.getTableInfo(this.store.title);
    this.dialogService.openTableInfoDialog(tableInfo);
  }

  addToWatchlist(isin: string) {
    if (this.isGuest) {
      this.dialogService.openFailureSnackBar('Abbonati ai servizi CedLab per usufruire dell\'esperienza completa');
      return;
    }

    this.addToWatchlistManager.addToWatchlist(isin);
  }
}
